import { FC, ReactNode, useCallback, useState } from 'react';
import { getPlatformStyles } from '@direct-frontend/platform-code';

import { cn } from '../../lib/css/className/className';
import { Drawer } from '../Drawer';
import { HStack, VStack } from '../Stack';

import { ButtonsContext } from './ModalButtons';
import { ModalProps } from './types';

getPlatformStyles({
    mobile: import('./Modal@mobile.css'),
});

export const cls = cn('Modal');

const Modal: FC<ModalProps> = function Modal(props) {
    const {
        isOpen,
        onClose,
        isDraggableMobile = true,
        children,
        'data-testid': dataTestId = 'Modal',
        className,
        dismissOnOutsideClick,
        dismissOnBack,
        bottomButtons,
        bottomButtonsType,
        isLoading,
        priority,
        onAnimationEnd,
        isFullscreenMobile = false,
        withoutPaddings,
        containerClassName,
        overlayClassName,
    } = props;
    const [buttons, onButtonsChange] = useState<ReactNode>(null);

    const StackComponent = bottomButtonsType === 'vertical' ? VStack : HStack;

    const handleAnimationEnd = useCallback(
        (animationState: '' | 'open' | 'close') => {
            onAnimationEnd?.(animationState);
        },
        [onAnimationEnd],
    );

    return (
        <Drawer
            data-testid={dataTestId}
            isOpen={isOpen}
            color="white"
            onClose={onClose}
            direction="bottom"
            isDraggable={isDraggableMobile && Boolean(onClose)}
            className={cls({ withoutPaddings }, [className])}
            footer={
                buttons || bottomButtons ? (
                    <VStack gap="8" className={cls('buttons')}>
                        {buttons}
                        {bottomButtons && (
                            <StackComponent className={cls('bottom-buttons')} gap="8">
                                {bottomButtons}
                            </StackComponent>
                        )}
                    </VStack>
                ) : null
            }
            dismissOnOutsideClick={dismissOnOutsideClick}
            dismissOnBack={dismissOnBack}
            isLoading={isLoading}
            priority={priority}
            isFullscreen={isFullscreenMobile}
            onAnimationEnd={handleAnimationEnd}
            containerClassName={containerClassName}
            overlayClassName={overlayClassName}
        >
            <ButtonsContext.Provider value={{ onButtonsChange }}>{children}</ButtonsContext.Provider>
        </Drawer>
    );
};

export default Modal;
